export default __webpack_public_path__ + "static/media/img_blog07.b2169504.jpg";